/* unplugin-vue-components disabled */module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"needHelp":"Нужна помощь?","phone":"Телефон","schedule":"Режим работы","instruction":"Инструкция по работе с кабинетом партнёра","subtitle":"Свяжитесь с менеджером или почитайте инструкцию по работе с кабинетом партнёра"}}')
  delete Component.options._Ctor
}
